import { RevealGroup, RevealItem } from "@/lib/motion";
import { Section, SectionHeading, Tag } from "./primitives";
import { GOVERNANCE } from "@/config/site";

export default function GovernanceSection() {
  return (
    <Section id="governance">
      <SectionHeading
        eyebrow="Governance"
        title="From Foundation to DAO"
        lead="Governance is designed to progressively decentralize across three stages."
      />

      <RevealGroup className="relative mt-16">
        {/* Connecting line (desktop) */}
        <div className="absolute left-0 top-8 hidden h-px w-full bg-gradient-to-r from-indigo-500/40 via-white/10 to-violet-500/40 lg:block" />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          {GOVERNANCE.map((g, i) => (
            <RevealItem key={g.stage} data-testid={`governance-stage-${i}`}>
              <div className="relative flex h-full flex-col gap-5 rounded-2xl border border-white/10 bg-white/[0.03] p-7 backdrop-blur-xl">
                <span className="relative flex h-4 w-4 items-center justify-center">
                  <span className="absolute h-4 w-4 rounded-full border border-indigo-400/50" />
                  <span className="h-2 w-2 rounded-full bg-indigo-400" />
                </span>
                <div>
                  <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-indigo-400">{g.stage}</div>
                  <h3 className="mt-2 font-display text-lg font-bold uppercase tracking-tight text-white">{g.title}</h3>
                </div>
                <p className="text-sm leading-relaxed text-gray-400">{g.body}</p>
                {g.tag && <Tag tone="future" className="mt-auto w-fit">{g.tag}</Tag>}
              </div>
            </RevealItem>
          ))}
        </div>
      </RevealGroup>
    </Section>
  );
}
